import _ from 'lodash';
import async from 'async';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { validateEmail } from '../../libs/utility';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';
import ActivatingDeliveryDialog from './ActivatingDeliveryDialog';

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';
import FMPTextField from '../ui/FMPTextField';
import DeleteIcon from '@material-ui/icons/Delete';
import Transition from './Transition';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
		marginTop : 30,
		marginBottom : 10,
	},
	supplierCheck : {
		paddingBottom : 10,
		color : '#666',
	},
	testBody : {
		border : '1px solid #ddd',
		padding : 10,
	},
	bodyPre : {
		whiteSpace: 'pre-wrap',
	},
	dialogPaper : {
		maxWidth : 1000,
		overflow: 'scroll',
	},
	row : {
		cursor : 'pointer',
	},
	button: {
		verticalAlign : 'middle',
		padding : '8px 10px',
	},
	submitButton : {
		fontSize : 18,
		borderRadius : '100px',
		padding : '20px 30px',
		textTransform: 'uppercase'
	},
	addInputButton : {
		borderRadius : '100px',
		marginTop : 20,
	},
});

const formFields = {
	additionalCarrierEmails : '',
	additionalSupplierEmails : '',
};



class ConfirmDeliveryDialog extends Component {
	constructor (props) {
		super(props);
		this.state = {
			isActiveDialogOpen: false,
			activatingStatus: 'pending',
			additionalCarrierEmails: [],
			additionalSupplierEmails: [],
			formFieldError : {},
		};
		this.handleClose = this.handleClose.bind(this);
		this.handleSchedule = this.handleSchedule.bind(this);
		this.closeActivatingDialog = this.closeActivatingDialog.bind(this);
	}

	componentDidMount () {
		//- Only used for updates
		const { stationDelivery } = this.props;
		if (stationDelivery) {
			const { additionalCarrierEmails, additionalSupplierEmails } = stationDelivery;
			this.setState({ additionalCarrierEmails,  additionalSupplierEmails });
		}
	}

	componentDidUpdate(prevProps) {
		const { stationDelivery } = this.props;
		if (
			_.isUndefined(prevProps.stationDelivery)
			&& stationDelivery
		) {
			const { additionalCarrierEmails, additionalSupplierEmails } = stationDelivery;
			this.setState({ additionalCarrierEmails,  additionalSupplierEmails });
		}
	}

	addInput (arrayName) {
		const val = _.cloneDeep(formFields[arrayName]);
		const newState = {
			[arrayName]: this.state[arrayName].concat([val])
		};
		this.setState(newState);
	}

	removeInput (arrayName, index) {
		const inputs = this.state[arrayName].slice();
		inputs.splice(index, 1);
		const newState = {[arrayName]: inputs};
		this.setState(newState);
	}

	onChange(event, fieldName, index, attr) {
		const newState = {};
		if (!_.isNumber(index)) {
			newState[fieldName] =  event.target.value;
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			newState[fieldName] =  inputs;
		}
		this.setState(newState);
	}

	handleClose () {
		this.props.onClose();
	}

	handleSchedule () {
		const {
			jobResult,
			updateDelivery,
			activateDelivery,
			showErrors,
		} = this.props;

		const {
			additionalCarrierEmails,
			additionalSupplierEmails
		} = this.state;

		const formFieldError = {};
		additionalCarrierEmails.forEach((email, i) => {
			if (validateEmail(email)) { return; }
			_.set(formFieldError, ['additionalCarrierEmails', i], 'Invalid characters in email');
		});

		additionalSupplierEmails.forEach((email, i) => {
			if (validateEmail(email)) { return; }
			_.set(formFieldError, ['additionalSupplierEmails', i], 'Invalid characters in email');
		});

		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isActiveDialogOpen: true,
			activatingStatus: 'activating'
		});

		const { stationDeliveryId } = jobResult;
		setTimeout(() => {
			async.waterfall([
				callback => {
					updateDelivery({
						params: {
							isInitialUpdate : true,
							stationDeliveryId,
							additionalCarrierEmails,
							additionalSupplierEmails
						},
						callback
					});
				},
				(r, callback) => {
					activateDelivery({
						params: {
							stationDeliveryIds: [stationDeliveryId],
						},
						callback
					});
				}
			], err => {
				//- error popup is already shown
				if (err) { console.error('There was an error'); }
				this.setState({activatingStatus: 'done'});
			});
		}, 2000);
	}

	closeActivatingDialog () {
		this.setState({isActiveDialogOpen: false});
	}

	render () {
		const {classes, jobResult, fullScreen } = this.props;
		const {additionalCarrierEmails} = this.state;
		if (!jobResult) { return null; }

		const {isActiveDialogOpen, activatingStatus} = this.state;
		/** @namespace jobResult.htmlBody **/
		/** @namespace jobResult.textBody **/
		/** @namespace jobResult.carrierEmailRecipients **/
		/** @namespace jobResult.supplierEmailRecipients **/
		/** @namespace jobResult.stationEmailGroups **/

		return (
			<Dialog
				fullScreen={fullScreen}
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						Verify and Schedule Delivery
					</DialogTitle>
					<DialogContent>
						<div
							className={classes.sectionHeader}
							style={{marginTop: 5}}
						>
							<span role="img" aria-label="success">🚚</span> Carrier Email Recipients
						</div>
						<div>
							{jobResult.carrierEmailRecipients.map((n, i) => {
								return (<div key={i}>{n}</div>);
							})}
						</div>

						{additionalCarrierEmails.map((email, i) => {
							return (<Grid container spacing={2} key={i}>
								<FMPTextField
									name={'additionalCarrierEmails'}
									index={i}
									label={"Email"}
									controller={this}
									md={8}
									contained={false}
								/>
								<Grid item xs={1} md={1}>
									<IconButton
										color="primary"
										aria-label="Delete"
										onClick={() => this.removeInput('additionalCarrierEmails', i)}
									>
										<DeleteIcon/>
									</IconButton>
								</Grid>
							</Grid>);
						})}

						<div>
							<Button
								variant="contained"
								className={classes.addInputButton}
								onClick={() => this.addInput('additionalCarrierEmails')}
							>
								ADD A CARRIER EMAIL
							</Button>
						</div>

						{jobResult.emailCopyOfDeliveryRequest && this.renderSupplierEmailSection()}

						{this.renderStationEmailSection()}

						<div className={classes.sectionHeader}>
							Email Subject
						</div>
						<div>
							{jobResult.subject}
						</div>

						<div className={classes.sectionHeader}>
							Email Body
						</div>
						<div className={classes.testBody}>
							<div dangerouslySetInnerHTML={{__html: jobResult.htmlBody}}/>
						</div>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose}>
							Cancel
						</Button>
						<Button
							disabled={isActiveDialogOpen}
							variant="contained"
							onClick={this.handleSchedule}
							className={classes.submitButton}
							color="primary"
						>
							Schedule Delivery
						</Button>
					</DialogActions>
				</div>

				<ActivatingDeliveryDialog
					open={isActiveDialogOpen}
					onClose={this.closeActivatingDialog}
					status={activatingStatus}
				/>

			</Dialog>
		);
	}

	renderSupplierEmailSection () {
		const {classes, jobResult} = this.props;
		const {additionalSupplierEmails} = this.state;
		return (<div>

			<div className={classes.sectionHeader}>
				<span role="img" aria-label="success">🛢</span> Supplier Email Recipients
			</div>

			<div className={classes.supplierCheck}>
				✓ Supplier will receive copy of delivery order after carrier has confirmed
			</div>

			<div>
				{jobResult.supplierEmailRecipients.map((n, i) => {
					return (<div key={i}>{n}</div>);
				})}
			</div>

			{additionalSupplierEmails.map((email, i) => {
				return (<Grid container spacing={2} key={i}>
					<FMPTextField
						name={'additionalSupplierEmails'}
						index={i}
						label={"Email"}
						controller={this}
						md={11}
						contained={false}
					/>
					<Grid item xs={1} md={1}>
						<IconButton
							color="primary"
							aria-label="Delete"
							onClick={() => this.removeInput('additionalSupplierEmails', i)}
						>
							<DeleteIcon/>
						</IconButton>
					</Grid>
				</Grid>);
			})}

			<div>
				<Button
					variant="contained"
					className={classes.addInputButton}
					onClick={() => this.addInput('additionalSupplierEmails')}
				>
					ADD A SUPPLIER EMAIL
				</Button>
			</div>
		</div>);
	}

	renderStationEmailSection () {
		const {classes, jobResult} = this.props;

		const {stationEmailGroups} = jobResult;

		if (_.isEmpty(stationEmailGroups)) {
			return (<div>
				No station emails will be sent.
			</div>);
		}

		return (<div>
			{stationEmailGroups.map((group, i) => {
				const {station, emails} = group;

				return (<div key={`group_${i}`}>
					<div className={classes.sectionHeader}>
						<span role="img" aria-label="success">⛽️</span> {station.number} - {station.name} Email Recipients
					</div>

					<div className={classes.supplierCheck}>
						✓ Station will receive copy of delivery order after carrier has confirmed
					</div>

					<div>
						{emails.map((email, j) => {
							return (<div key={j}>{email}</div>);
						})}
					</div>
				</div>);
			})}
		</div>);
	}
}

ConfirmDeliveryDialog.propTypes = {
	classes: PropTypes.object.isRequired,
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	updateDelivery : PropTypes.func.isRequired,
	activateDelivery : PropTypes.func.isRequired,
	jobResult : PropTypes.object,
	stationDelivery : PropTypes.object,
	fullScreen: PropTypes.bool.isRequired,
	showErrors : PropTypes.func,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmDeliveryDialog);